// JavaScript source code
import { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Login from './components/Login';
import Layout from './components/shared/Layout';
import { HelmetProvider } from 'react-helmet-async';
import Logout from './components/Logout';
import LoggedOut from './components/LoggedOut';
import ChangePassword from './components/ChangePassword';
import ChangeUsername from './components/ChangeUsername';
import GuardedRoute from './components/shared/GuardedRoute';
import session from '../scripts/radresponder.modules.session';
import InitializeTimeoutPrompt from '../scripts/radresponder.logoffprompt';
import $ from 'jquery';
import ko from 'knockout';
import rr from '../scripts/radresponder';
import 'knockout-mapping';
import SelectOption from './components/SelectOption';
import VerifyCode from './components/VerifyCode';
import SetupAuthenticator from './components/SetupAuthenticator';
import VerifyAuthenticator from './components/VerifyAuthenticator';
import './Styles';

function App() {
    const [config] = useState(window.rrConfig);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const promptDurationInSeconds = 60;

    const checkAuthentication = useCallback(async () => {
        const authData = await session.isUserAuthenticatedToServer();
        setIsAuthenticated(authData.authenticated);
        setIsLoading(false);
    }, []);

    useEffect(() => {
        (async () => {
            const data = await $.post(rr.getApiAddress() + "account/getuserinfo");

            if (!data) {
                return;
            }

            //check to see if user has a personnel id, and if not, send to old site
            if (!data.personnelId) {
                window.location.href = `/app/account/login?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`;
                return;
            }

            session.currentUserInfo(ko.mapping.toJS(data));
        })();
    }, []);

    useEffect(() => {
        if (config) {
            InitializeTimeoutPrompt(config.webAuthenticationTimeoutInSeconds, promptDurationInSeconds);
            checkAuthentication();
        }
    });

    return (
        <HelmetProvider>
            <div className="App">
                <Router>
                    <Layout config={config}>
                        {isLoading ? "Loading..." :
                            <Switch>
                                <Route path="/app/account/login"><Login setIsAuthenticated={setIsAuthenticated} /></Route>
                                <Route path="/app/account/multifactor/selectoption"><SelectOption setIsAuthenticated={setIsAuthenticated} /></Route>
                                <Route path="/app/account/multifactor/verifycode"><VerifyCode setIsAuthenticated={setIsAuthenticated} /></Route>
                                <Route path="/app/account/multifactor/setupauthenticator"><SetupAuthenticator setIsAuthenticated={setIsAuthenticated} /></Route>
                                <Route path="/app/account/multifactor/verifyauthenticator"><VerifyAuthenticator setIsAuthenticated={setIsAuthenticated} /></Route>
                                <Route path="/app/account/logout"><Logout setIsAuthenticated={setIsAuthenticated} /></Route>
                                <Route path="/app/account/loggedout"><LoggedOut /></Route>
                                <Route>
                                    <div id="applicationHost">
                                        <div className="shell">
                                            <div className="main-content" id="mainContent" tabIndex="-1">
                                                <div className="page-host">
                                                    <Switch>
                                                        <GuardedRoute auth={isAuthenticated} path="/app/account/changepassword/:personnelId?" component={ChangePassword} />
                                                        <GuardedRoute auth={isAuthenticated} path="/app/account/changeusername/:personnelId?" component={ChangeUsername} />
                                                    </Switch>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Route>
                            </Switch>
                        }
                    </Layout>
                </Router>
            </div>
        </HelmetProvider>
    );
}

export default App; 